/**
 * Where the global mobile/tablet top bar belongs.
 *
 * ONE list, three consumers: the bar itself, the inset provider that tells
 * screens the top safe area is already paid, and the toast host that has to
 * clear it. Putting the predicate here is what keeps those three from
 * disagreeing the day a route is added.
 *
 * TAB ROOTS ONLY. Profile already owns its purple header with avatar and name,
 * and every screen with a back control keeps its own ScreenHeader. Nested
 * routes (/trips/<id>, /messages/<id>, /hosting/new-listing/...) therefore do
 * NOT show the bar — the exact comparison below is the whole rule.
 */
const MOBILE_TOP_NAV_ROOTS = [
  '/explore',
  '/trips',
  '/tours',
  '/hosting',
  '/messages',
  '/services',
] as const

/**
 * `pathname` comes from `usePathname()`, which drops the `(tabs)` group — so the
 * tab roots arrive as `/explore`, `/trips`, and so on. Query strings and hashes
 * never reach it, but strip them anyway: a predicate that depends on how the
 * router formats its output is a predicate that breaks on a router upgrade.
 */
export function shouldShowMobileTopNav(pathname: string | null | undefined): boolean {
  if (!pathname) return false
  const clean = pathname.split('?')[0]?.split('#')[0]?.replace(/\/+$/, '') || '/'
  return (MOBILE_TOP_NAV_ROOTS as readonly string[]).includes(clean)
}
